var path = 'app/scripts/modules/ecs/serverGroup/configure/wizard/verticalScaling/verticalScaling.html';
var html = "<div class=\"clearfix\">\n  <div class=\"row\">\n    <div class=\"col-md-12\">\n      <ecs-server-group-vertical-scaling command=\"command\" application=\"application\"></ecs-server-group-vertical-scaling>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/ecs/serverGroup/configure/wizard/verticalScaling/verticalScaling.html
// module id = 1622
// module chunks = 0